module.exports = {

  /**
   * Counter for number of syncs in progress
   * @type {Number}
   */
  syncCount: 0,

  /**
   * Define the start point of a sync operation
   */
  startSync: function() {
    ++this.syncCount;
  },

  /**
   * Define the end point of a sync operation
   */
  endSync: function() {
    --this.syncCount;
  },

  /**
   * Return whether a 'sync' operation is in progress on this collection
   * @returns {boolean}
   */
  isSyncing: function() {
    return this.syncCount > 0;
  }

};



// WEBPACK FOOTER //
// ./app/assets/js/mixins/syncCount.js